// extracted by mini-css-extract-plugin
export default {"actionsMenuContainer":"ActionsMenu_actionsMenuContainer__pw1gU","actionsMenu":"ActionsMenu_actionsMenu__h9nqn"};